module.exports = __webpack_public_path__ + "static/img/wdys1-2.5674efd.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdys1-2.png
// module id = 887
// module chunks = 0